import React,{useState} from 'react';
import './Payment.scss';
import {Link} from "react-router-dom"

const PaymentClose = React.createContext();
const Payment = () => {
    const clearCartInput = () =>{
        const input = document.getElementById('card-number')
        input.value=" ";
        
    }
    const clearDateInput = () =>{
        const input = document.getElementById('card-date')
        input.value=" ";    
    }
     return (
        <div className="payment">
            <div className="payment-box d-flex flex-column align-items-center justify-content-center">
                <Link to="/categories/courses" className="closewindow"><i className="material-icons btn btn-danger">close</i></Link>
                <div className="payment-price">
                    <h3 className="payment-course-name">Huquqiy bilimni oshirish</h3>
                    <h3 className="price">45000.00 so'm</h3>
                </div>
                <form className="payment-form">
                    <div className="form-group ">
                        <label for="cart-number">
                            *Karta
                        </label>
                        <div className="cart-number" >
                            <input required type="text" id="card-number" className="form-control" placeholder="86001234567..." /><span className="clear-input" onClick={clearCartInput}><i className="material-icons">close</i></span>
                        </div>
                    </div>
                    <div className="row cart-options">
                        <div className="form-group col-md-6 ">
                            <label for="cart-date">
                                *CC/VV
                            </label>
                            <div className="cart-date">
                                <input required type="text" id="card-date" className="form-control" placeholder="10 / 2024" /><span className="clear-input" onClick={clearDateInput}><i className="material-icons">close</i></span>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="check">
                                Chek
                            </label>
                            <div >
                                <a download href="../../assets/download/check.doc" className="form-control check"  >Chekni Yuklash<span><i className="material-icons">download</i></span></a>
                            </div>
                        </div>
                    </div>
                    <div className="row cart-info ">
                        <p>
                        Barcha to'lovlar **** 5245 ta kartadan olinadi.
                        Siz kartani hisob sozlamalarida almashtirishingiz mumkin
                        </p>
                    </div>
                    <div className="row cart-options">
                        <div className="form-group checkbox col-md-6">
                            <input type="checkbox"id="save-checkbox"/>
                            <label for="save-checkbox">Saqlash</label>
                        </div>
                        <div className="form-group  checkbox col-md-6">
                            <input type="checkbox" id="skip"/>
                            <label for="skip">O'tgazib yuborish</label>
                        </div>  
                      
                    </div>  
                    <div className="form-group text-center mt-3">
                            <Link to="/categories/courses/modules"className="button button-primary">To'lov qilish</Link>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Payment;
